import React, { Component } from 'react';
import { connect } from 'react-redux';
import { List, ListItem, ListItemIcon, ListItemText } from '../bundles/ListBundle';
import { DoSync, ReportProgress } from "../actions/SyncActions";
import { SetPrivilegedUser } from "../actions/SettingsActions";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
    LocalShippingIcon
} from "../bundles/IconsBundle";
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from "@material-ui/core/Typography";
import { Text } from '../extensions/LangaugeContainer';


class DriverList extends Component {

    state = {
        dialogOpen: false,
        currentDriverName: "",
        currentDriverLKWId: null
    }

    syncForSpecificUser = (e, data) => {
        console.log(data);
        let settings = this.props.settings;
        settings.CurrentUserId = this.state.currentDriverLKWId;
        settings.CurrentUserName = this.state.currentDriverName;
        this.props.DoSync(settings, this.props.ReportProgress);

        //Set privilegedUser to true, so that the view can be read only.
        this.props.SetPrivilegedUser(true);
    }

    setDataForCurrentDriver = (e, data) => {
        this.setState({
            currentDriverName: data.Name,
            currentDriverLKWId: data.LKW_id,
            dialogOpen: true,
        });
    }

    render() {
        console.log("Deriver list props :", this.props);
        return (
            <div>
                <List>
                    {this.props.drivers.map(item => {
                        return (
                            <ListItem
                                button
                                onClick={(e) => this.setDataForCurrentDriver(e, item)}
                                key={item.id}>
                                {/* <ListItemIcon>
                            </ListItemIcon> */}
                                <ListItemText primary={item.Berater} />
                            </ListItem>
                        )
                    })}


                </List>
                <Dialog
                    maxWidth="xs"
                    fullWidth={true}
                    open={this.state.dialogOpen}
                    onClose={this.props.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Driver list sync</DialogTitle>
                    <DialogContent>
                        <div>
                            <LocalShippingIcon style={{ fontSize: 44, color: "#0080DE" }} />
                        </div >
                        {this.props.sync.syncInProgress && (
                            <div>
                                <LinearProgress />
                                <br />
                                <Typography component="div" style={{ color: "#FFFFFF", fontSize: 16 }}><Text tid="dbLoading" />...</Typography>
                            </div>
                        )}
                        <div>

                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => this.setState({dialogOpen: false})} color="primary">
                            <Text tid="cancel" />
                        </Button>
                        <Button
                            style={{ color: "#FFFFFF", backgroundColor: "#0080DE" }}
                            variant="contained"
                            onClick={this.syncForSpecificUser}
                        >
                            <Text tid="sync" />
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    application: state.app,
    pageTitle: state.app.pageTitle,
    settings: state.settings,
    drivers: state.tasks.driverList,
    sync: state.sync
});

export default connect(
    mapStateToProps,
    { DoSync, ReportProgress, SetPrivilegedUser }
)(DriverList);
